import React from "react";
import { Link } from "react-router-dom";
import { all_routes as route } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";

const FaqG2G = () => {
  const faqs = [
    {
      question: "What is Ausbildung, and how can I apply from Bangladesh?",
      answer:
        "Ausbildung is a vocational training program in Germany that combines classroom learning with practical work. To apply, you need German language proficiency (usually B1 level), a CV in German format, and a completed application with a company offering Ausbildung.",
    },
    {
      question: "Do I need to learn German before starting the process?",
      answer:
        "Yes. Learning German up to B1 level is essential for Ausbildung or study programs in Germany. Guideline2Germany offers A1–B1 courses with live classes, mock exams, and personalized guidance.",
    },
    {
      question: "Can I get a visa after completing this course?",
      answer:
        "Our course prepares you for the entire process — language, document preparation, interviews, and application — increasing your chances of getting a visa significantly.",
    },
    {
      question: "Is it possible to study in Germany without a block account?",
      answer:
        "While most students need a blocked account, Ausbildung applicants may not always require it. We guide you based on your chosen path.",
    },
    {
      question: "How much does the Ausbildung preparatory program cost?",
      answer:
        "The full course costs 225,000 BDT, payable in up to 6 installments (37,500 BDT each).",
    },
    {
      question: "What makes Guideline2Germany different?",
      answer:
        "We’re a one-stop platform from Bangladesh specializing in German Ausbildung and study preparation — from language courses to mentorship, document support, and job/visa guidance.",
    },
  ];

  return (
    <section className="bg-white py-16">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-[#009fe3] mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600">
            Common queries from Bangladeshi students preparing for Ausbildung or
            study in Germany.
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg shadow-sm p-5 bg-gray-50"
            >
              <h4 className="text-lg font-semibold text-gray-800 mb-2">
                {faq.question}
              </h4>
              <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <ImageWithBasePath
            src="assets/img/feature/feature-4.jpg"
            alt="faq banner"
            className="rounded-lg mx-auto w-full max-w-xl shadow"
          />
        </div>

        <div className="bg-gray-100 border rounded-xl p-6 sm:p-8 mt-12">
          <div className="text-center">
            <h4 className="text-2xl font-semibold mb-2 text-gray-800">
              Still have a question?
            </h4>
            <p className="mb-4 text-gray-600">
              We'd be happy to help you with any questions you have! Please let
              us know what you're looking for, and we'll do our best to assist
              you.
            </p>
            <Link
              to={route.contactUs}
              className="inline-block bg-[#009fe3] hover:bg-[#007cb5] text-white px-6 py-3 rounded font-medium"
            >
              Contact us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqG2G;
